import { BaseModel, convertToArrayModels, convertToModel, fillOwnProperties } from '~/shared/model'
import { isUnknownObject } from '~/shared/utils/guards'
import { toCroppedImage } from '~/shared/utils/image'
import LandingBannerButton from './LandingBannerButton'
import LandingLogoItem from './LandingLogoItem'

export default class LandingRectangularBannerBlock extends BaseModel {
  static override constructorName = 'LandingRectangularBannerBlock'

  readonly name = 'rectangular_banner_block'

  title: string = ''
  text: string = ''
  logos: LandingLogoItem[] = []
  'background_image': string = ''
  button: LandingBannerButton = new LandingBannerButton()
  'is_show_feedback_button': boolean = false

  constructor(data?: unknown) {
    super(data)
    if (isUnknownObject(data)) {
      fillOwnProperties(this, data, ['logos', 'background_image', 'button', 'is_show_feedback_button'])

      this.logos = convertToArrayModels(data.logos, LandingLogoItem)
      this.background_image = toCroppedImage(data.background_image)
      this.button = convertToModel(data.button, LandingBannerButton, new LandingBannerButton())
      this.is_show_feedback_button = Boolean(Number(data.is_show_feedback_button))
    }
  }
}
